import angular from 'angular';

import {ResetPasswordComponent} from './resetPassword.component';

export const ResetPwModule = angular
        .module('mmsApp.pages.resetPw', [
        ])
        .config(($stateProvider) => {
            'ngInject';
            $stateProvider
                .state('pages.resetPw', {
                    data: {
                        isAuthRequired: false,
                    },
                    url: '/resetPw?token',
                    params: {
                        token: ''
                    },
                    component: ResetPasswordComponent.name,
                    resolve: {
                        token: ($transition$) => {
                            return $transition$.params().token;
                        },
                    }
                });
        })
        .component(ResetPasswordComponent.name, ResetPasswordComponent.component)
        .name
    ;


// WEBPACK FOOTER //
// ./src/app/pages/resetPw/resetPassword.module.js